module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAB5SURBVDhPY/hPIgBpePv9z71PPx/gRvc//nz65fe/f/+gGrY//Fx76kXj6Ve4UN2plzOuvPv1F6Zh5+PPTWdetp19hQs1n3k159q733ANu6AaXrefw47AGt6PaqCxBpIjbvsjEpPG2x+gxHcfI83B0T20xEcC+P8fAKPOiA2pD6OAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/discrete_choice-node.png
// module id = 981
// module chunks = 0